/**
 * Mock de diseño — resumen comercial comprador/despacho (Fase Plataforma).
 * No persiste ni conecta APIs de administración de compradores.
 */

export const COMPRADOR_DESIGN_NOTICE =
  "Vista de diseño / datos de ejemplo. La administración real de compradores, vigencias por módulo y límites comerciales se implementará en un PR posterior sin modificar license_engine en esta fase.";

export const MOCK_COMPRADOR_PROFILE = {
  nombre_comercial: "Despacho Contable Baldemar",
  rfc: "BVL1908211D6",
  correo_principal: "admin@despacho-demo.local",
  usuario_dueno: "admin@visorfiscal.mx",
  estado_comercial: "Activo",
  fecha_inicio: "2025-01-15",
  fecha_vencimiento: "2026-12-31",
  dias_restantes: 198,
  plan: "Profesional",
};

export const MOCK_MODULOS_CONTRATADOS = [
  {
    id: "visor",
    label: "Visor Fiscal CFDI",
    workModuleId: "visor_sat",
    contratado: true,
    estado: "Activo",
    fecha_inicio: "2025-01-15",
    fecha_vencimiento: "2026-12-31",
    dias_restantes: 198,
    limite: null,
  },
  {
    id: "laboral",
    label: "Asistente Laboral / REPSE",
    workModuleId: "asistente_laboral",
    contratado: true,
    estado: "Activo",
    fecha_inicio: "2025-06-01",
    fecha_vencimiento: "2026-12-31",
    dias_restantes: 198,
    limite: null,
  },
  {
    id: "tramites",
    label: "Trámites Fiscales",
    workModuleId: "tramites_fiscales",
    contratado: true,
    estado: "Activo",
    fecha_inicio: "2025-01-15",
    fecha_vencimiento: "2026-12-31",
    dias_restantes: 198,
    limite: null,
  },
  {
    id: "despacho",
    label: "Gestión Despacho",
    workModuleId: "gestion_despacho",
    contratado: true,
    estado: "Activo",
    fecha_inicio: "2026-06-01",
    fecha_vencimiento: "2026-12-31",
    dias_restantes: 198,
    limite: "Auxiliares y clientes operativos",
  },
];

export const MOCK_LIMITES_DESPACHO = {
  plan: "Profesional",
  auxiliares_autorizados: 10,
  auxiliares_activos: 3,
  auxiliares_disponibles: 7,
  clientes_operativos_autorizados: 50,
  clientes_operativos_registrados: 12,
};

export const MOCK_NOTAS_SIGUIENTE_FASE = [
  "Distribuidor: activar/desactivar módulos por comprador desde catálogo o cartera (PR backend separado).",
  "Comprador: leer vigencias reales por módulo desde token v2 y capabilities (sin tocar license_engine en esta fase).",
  "Límites comerciales: validar max_auxiliares y max_clientes_operativos en emisión y en runtime.",
  "Cliente operativo (despacho_clients) ≠ cliente fiscal (clients): mantener separación en UI y permisos.",
  "Unificar vista comprador en Panel General o /despacho/comprador con datos reales cuando existan endpoints de solo lectura.",
];

export const ESTADO_COMERCIAL_TONES = {
  Activo: "info",
  Suspendido: "warn",
  Vencido: "critical",
  "En prueba": "neutral",
};

export const MODULO_ESTADO_TONES = {
  Activo: "info",
  Vencido: "critical",
  Suspendido: "warn",
  "No contratado": "neutral",
};
